/* Granatelli filter drawer
   On mobile / tablet (≤900px), the filter pills move into a slide-in drawer.
   Behavior:
     - Clicking .gm-filter-trigger opens the drawer (slides in from right + overlay).
     - Clicking the overlay, the X button, or pressing Escape closes it.
     - "View results" closes the drawer (filters already applied via Dawn AJAX submission).
     - "Clear all" navigates to the bare collection URL.
     - Active filter count badge on the trigger button updates from URL params.
     - Body scroll is locked while the drawer is open.

   The drawer itself is just .facets-wrapper transformed into a fixed off-canvas
   panel via CSS — this script only handles open/close state + accessibility.
*/
(function () {
  'use strict';

  var SCROLL_LOCK_CLASS = 'gm-drawer-scroll-lock';

  function init() {
    var wrap = document.querySelector('.gm-collection-grid-wrap');
    if (!wrap || wrap.__gmFilterDrawerInit) return;

    var trigger = wrap.querySelector('.gm-filter-trigger');
    var aside = wrap.querySelector('.facets-wrapper');
    var overlay = wrap.querySelector('.gm-filter-drawer-overlay');
    var closeBtn = wrap.querySelector('.gm-drawer-close');
    var applyBtn = wrap.querySelector('.gm-drawer-apply');
    if (!trigger || !aside || !overlay) return;

    wrap.__gmFilterDrawerInit = true;

    function isOpen() {
      return document.body.classList.contains('is-filter-drawer-open');
    }

    function open() {
      document.body.classList.add('is-filter-drawer-open');
      wrap.classList.add('is-filter-drawer-open');
      trigger.setAttribute('aria-expanded', 'true');
      overlay.hidden = false;
      document.documentElement.classList.add(SCROLL_LOCK_CLASS);
      document.body.classList.add(SCROLL_LOCK_CLASS);
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 50);
      }
    }

    function close() {
      document.body.classList.remove('is-filter-drawer-open');
      wrap.classList.remove('is-filter-drawer-open');
      trigger.setAttribute('aria-expanded', 'false');
      overlay.hidden = true;
      document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
      document.body.classList.remove(SCROLL_LOCK_CLASS);
      if (trigger && document.activeElement !== trigger) trigger.focus();
    }

    function toggle() {
      if (isOpen()) close();
      else open();
    }

    /* If the section re-rendered (Shopify section reload) and body still has
       the open class, sync the trigger + wrap state to match. */
    if (isOpen()) {
      wrap.classList.add('is-filter-drawer-open');
      trigger.setAttribute('aria-expanded', 'true');
      overlay.hidden = false;
    }

    trigger.addEventListener('click', toggle);
    overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (applyBtn) applyBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && wrap.classList.contains('is-filter-drawer-open')) {
        close();
      }
    });

    /* Auto-close the drawer if user resizes above tablet width */
    var mq = window.matchMedia('(min-width: 901px)');
    function onBreakpointChange() {
      if (mq.matches && wrap.classList.contains('is-filter-drawer-open')) close();
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange);
    else if (mq.addListener) mq.addListener(onBreakpointChange);

    /* ----------------------------------------------------------------
       Active-filter count badge on the trigger button (e.g. "Filters (3)")
       Counts every distinct filter.* URL param that contains a value.
       ---------------------------------------------------------------- */
    function updateActiveCount() {
      var badge = trigger.querySelector('[data-gm-filter-count]');
      if (!badge) return;
      var params = new URLSearchParams(window.location.search);
      var count = 0;
      params.forEach(function (value, key) {
        if (!value) return;
        if (key.indexOf('filter.') === 0) count++;
      });
      if (count > 0) {
        badge.textContent = count;
        badge.classList.add('is-active');
        trigger.classList.add('has-active-filters');
      } else {
        badge.textContent = '';
        badge.classList.remove('is-active');
        trigger.classList.remove('has-active-filters');
      }
    }
    updateActiveCount();
    document.addEventListener('shopify:section:load', updateActiveCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
